<script>
export default {};
</script>
<template>
  <div class="search_btn">
    <div class="btn">All results (2,000+)</div>
  </div>
</template>
<style lang="scss" scoped>
.search_btn {
  border-top: 1px solid #f4f4f4;
  padding: 20px 0px;
  .btn {
    font-size: 12px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    background: #0275b1;
    color: #fff;
    border-radius: 4px;
    padding: 10px;
  }
}
</style>
